import { useState } from 'react'

import { Card, Section, TogglerCheckbox } from '@factorialco/deprecated-design-system'

import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import i18n from 'modules/core/lib/i18n'

import ApprovalsBlock from 'modules/approvals/components/ApprovalsConfigurationBlock'
import { useApprovalFeatures } from 'modules/approvals/hooks/useFeatureLimits'
import atsCompanies from 'modules/ats/store/collections/atsCompanies'
import RequestUpgradeModal from 'modules/upsell/components/RequestUpgradeModal'
import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'

export const RequisitionsSettings = () => {
  const { canAddGroup } = useApprovalFeatures('ats')
  const [showUpgradeModal, setShowUpgradeModal] = useState(false)
  const atsCompany = atsCompanies.current
  const hasRequisitionsEnabled = !!atsCompany?.attributes.requisitions_enabled

  const { performAction: changeRequisitionsSettings } = useAsyncAction(async () => {
    await atsCompany?.toggleJobRequisitions()
  })

  if (!atsCompany) {
    return null
  }

  return (
    <>
      <Section
        illustration="diamond"
        title={i18n.t('app_store_v2.apps.ats.settings.requisitions.title')}
        description={i18n.t('app_store_v2.apps.ats.settings.requisitions.description')}
        link={{
          label: i18n.t('app_store_v2.apps.ats.settings.requisitions.learn_more'),
          href: i18n.t('app_store_v2.apps.ats.settings.requisitions.help_center_url'),
        }}
      >
        <Card>
          <Card.Title
            size="small"
            action={
              <TogglerCheckbox
                value={hasRequisitionsEnabled}
                onChange={changeRequisitionsSettings}
              />
            }
          >
            {i18n.t('app_store_v2.apps.ats.settings.requisitions.toggle.title')}
          </Card.Title>
          <Card.Description>
            {i18n.t('app_store_v2.apps.ats.settings.requisitions.toggle.description')}
          </Card.Description>
        </Card>
      </Section>
      {showUpgradeModal && (
        <RequestUpgradeModal
          requestReason={ValidReasons.UpgradeFromLegacy}
          requestSource="marketplace-legacy-apps"
          onClose={() => setShowUpgradeModal(false)}
        />
      )}
      {hasRequisitionsEnabled && (
        <ApprovalsBlock
          category="ats"
          title={i18n.t('app_store_v2.apps.ats.settings.requisitions.approvals.title')}
          description={i18n.t('app_store_v2.apps.ats.settings.requisitions.approvals.description')}
          multigroup
          icon={'document-approved'}
          hideAddGroupButton={!hasRequisitionsEnabled && !canAddGroup()}
          helpCenterUrlName="ats_requisitions"
          onAddGroup={
            !canAddGroup()
              ? () => {
                  setShowUpgradeModal(true)
                }
              : undefined
          }
        />
      )}
    </>
  )
}
